// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"349":"2d3fcc71","775":"55f6ab6d","799":"71078438"}[chunkId] + ".js";
};